import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AlertBar } from '../../Modals/AlertBar';
import MapAlertSummaryReport from '../../components/Report/MapAlertSummaryReport';




class ModalReportSummaryByGroup extends Component {

    constructor() {
        super();
        this.mapAlert = React.createRef();
        this.state = {
            isShowMap: false,
            sLat: '',
            sLong: '',
            eLat: '',
            eLong: '',
            isFullScreen: false,
            statusLocation: 'start'
        }
    }

    onClickLatLong = (sLat, sLong, eLat, eLong, statusLocation) => {
        this.setState({
            isShowMap: true,
            sLat,
            sLong,
            eLat,
            eLong,
            statusLocation
        });
    }

    handleFullScreenToggle = () => {
        const { isFullScreen } = this.state;
        if (!isFullScreen) {
            this.setState({isFullScreen: true});
        } else {
            this.setState({isFullScreen: false});
        }
    }

    render(){
        const {
            device_no,
            onClickBackToReportSummary,
            speedOverSummaryList,
            symbolId,
            symbolColor
        } = this.props;
        const {
            isShowMap,
            sLat,
            sLong,
            eLat,
            eLong,
            isFullScreen,
            statusLocation
        } = this.state;

        // console.log('sLat:', sLat);
        // console.log('sLong:', sLong);
        // console.log('eLong:', eLong);
        // console.log('eLat:', eLat);
        // console.log('speedOverSummaryList:', speedOverSummaryList);
        return(
            <div className="modal-confirm" style={{ display: 'block', top: 'auto', height: '100%', position: 'absolute' }} >
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '80%'}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title custom_align" id="Heading">{device_no}</h4>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-hidden="true"
                                style={{padding: '0px', margin: '0px', position: 'inherit'}}
                                onClick={onClickBackToReportSummary} >
                                <span className="fa fa-times" aria-hidden="true" />
                            </button>
                        </div>
                        <div className="modal-body">
                            <table border='1' className="table table-fixed table-bordered no-margin" style={{fontSize: '14px', backgroundColor: 'white'}}>
                                <thead >
                                <tr>
                                    <th width="60" className="text-center">#</th>
                                    <th width="120" className="text-center">เริ่มเวลา</th>
                                    <th>ตำแหน่ง</th>
                                    <th width="100" className="text-center">สิ้นสุดเวลา</th>
                                    <th>ตำแหน่ง</th>
                                    <th width="80" className="text-center">รวม (นาที)</th>
                                    <th width="80" className="text-center">ความเร็วสูงสุด</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    speedOverSummaryList && speedOverSummaryList.map((data, key) => {
                                     return (
                                         <tr key={key}>
                                             <td>{key + 1}</td>
                                             <td>{data.start_dtm}</td>
                                             <td style={{cursor: 'pointer'}} onClick={() => this.onClickLatLong(data.start_at_latitude, data.start_at_longitude, data.end_at_latitude, data.end_at_longitude, 'start') } >{data.start_at_place} {`(${data.distance})`}</td>
                                             <td>{data.end_dtm}</td>
                                             <td style={{cursor: 'pointer'}} onClick={() => this.onClickLatLong(data.start_at_latitude, data.start_at_longitude, data.end_at_latitude, data.end_at_longitude, 'end') } >{data.end_at_place} {`(${data.distance})`}</td>
                                             <td>{data.elapse_time_s}</td>
                                             <td>{data.max_speed}</td>
                                         </tr>
                                        )
                                     })
                                }
                                </tbody>
                            </table>
                        </div>

                        <div className="modal-footer ">
                            <button className="btn btn-primary" onClick={onClickBackToReportSummary} >ตกลง</button>
                        </div>
                    </div>
                    {/* /.modal-content */}
                </div>
                { isShowMap &&
                <div className="modal-confirm" style={{ display: 'block', top: '-1000px'}} >
                        <div className="modal-dialog modal-dialog-centered" style={{maxWidth: isFullScreen ? '80%' : '' }}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title custom_align" id="Heading">{''}</h4>
                                    <button
                                        type="button"
                                        id="buttonMapAlert"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-hidden="true"
                                        style={{padding: '0px', margin: '0px', position: 'inherit'}}
                                        onClick={() => this.setState({isShowMap: false})} >
                                        <span className="fa fa-times" aria-hidden="true" />
                                    </button>
                                </div>
                                <div className="modal-body" id="carAlertRow">
                                    <MapAlertSummaryReport
                                        index={1}
                                        lat={statusLocation === 'start' ? sLat : eLat}
                                        lng={statusLocation === 'end' ? eLat : eLong}
                                        text={device_no}
                                        symbolId={symbolId}
                                        symbolColor={symbolColor}
                                        handleFullScreenToggle={() => this.handleFullScreenToggle()}
                                        isFullScreen={isFullScreen}
                                    />
                                    <button className="btn btn-primary pull-right" onClick={() => this.setState({ isShowMap: false })}  >ตกลง</button>
                                </div>
                            </div>
                            {/* /.modal-content */}
                        </div>
                    </div>
                }
            </div>
        );
    }
}

ModalReportSummaryByGroup.propTypes = {
    onClickBackToReportSummary: PropTypes.func.isRequired,
    device_no: PropTypes.string.isRequired,
    speedOverSummaryList: PropTypes.array.isRequired,
    symbolId:  PropTypes.string.isRequired,
    symbolColor: PropTypes.string.isRequired
}

export default ModalReportSummaryByGroup;



// WEBPACK FOOTER //
// ./src/app/view/components/Report/ModalReportSummaryByGroup.js